import { z } from "zod";

export const ItemControleEstoqueSchema = z.object({
  IdItemControleEstoque: z.number().int().optional(), 
  IdProdutoServico: z.coerce.number().int().nullable().optional(),
  QtdeEstoqueMin: z.coerce.number().nullable().optional(),
  QtdeEstoqueMax: z.coerce.number().nullable().optional(),
  
  LocalArmazenamento: z.string().nullable().optional(),
  Delete: z.boolean().nullable().optional().default(false),
  NomeProdutoServico: z.string().optional(),
})

export type ItemControleEstoqueForm = z.infer<typeof ItemControleEstoqueSchema>;